import * as React from 'react';

import { ClauseResponse } from '../../store/details/policy/model';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { getI18n } from '../../store/utils/i18n/strings.manager';

interface ClauseInformationProps {
  readonly headerText: string;
  readonly headerColor?: string;
  readonly information: ClauseResponse[];
  readonly translation?: string;
}

const styles = {
  informationContainer: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    marginLeft: '10px'
  },
  clauseContainer: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    marginBottom: '10px',
    borderBottom: '1px solid #8fabd9'
  },
  clauseHeader: {
    display: 'flex',
    flexDirection: 'row' as 'row'
  },
  clauseBold: {
    fontWeight: 'bolder' as 'bolder'
  },
  clauseCode: {
    fontWeight: 'bolder' as 'bolder',
    marginRight: '10px'
  }
};

class ClauseInformation extends React.PureComponent<ClauseInformationProps> {
  private localization: Ii18n;

  constructor(props: ClauseInformationProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    const info = this.props.information.map((clause, i) => {
      return (
        <div style={styles.clauseContainer} key={i}>
         <div style={styles.clauseHeader}>
           <span style={styles.clauseCode}>
             {`${this.localization.get(`${this.props.translation}.code`)} ${clause.code}`}
           </span>
           <span style={styles.clauseBold}>
             {clause.name ? `${this.localization.get(`${this.props.translation}.name`)} ${clause.name}` : null}
           </span>
         </div>
         <div>
           <span>
             {clause.description.map((text, k) => k ? [<br key={k}/>, text] : text)}
           </span>
         </div>
       </div>
      );
    });
    return (
      <div>
        <div style={styles.informationContainer}>
          {info}
        </div>
      </div>
    );
  }
}

export { ClauseInformation };
